var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBallLitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35033 19.977C3.82815 19.6058 -0.348288 14.8261 0.0229515 9.35033C0.440595 3.82815 5.17389 -0.348288 10.6961 0.0229515C16.1718 0.440595 20.3483 5.17389 19.977 10.6961C19.6058 16.1718 14.8261 20.3483 9.35033 19.977Z",
    fill: "url(#paint0_radial_821_77504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_821_77504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2313 7.1384) rotate(92.7179) scale(14.0655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00887753,
    stopColor: "#C9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1723,
    stopColor: "#B5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377898,
    stopColor: "#A9E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582742,
    stopColor: "#78D4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800743,
    stopColor: "#00B4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0198CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallLitle);
export default __webpack_public_path__ + "static/media/ballLitle.7c4a09cec9d65e74449bddfa92b55bdc.svg";
export { ForwardRef as ReactComponent };